<template>
  <div style="margin: 10px 20px 0px">
    <el-form style="margin-right: 30px" :model="editAccForm" :rules="editAccRules" ref="editAccForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="用户名" prop="username">
        <span>{{editAccForm.username}}</span>
      </el-form-item>
      <el-form-item label="权限" prop="role">
        <el-select v-fixZoom :disabled="isShowRole" filterable v-model="editAccForm.role" placeholder="请选择权限" style="width: 100%">
          <el-option
            v-for="item in roleOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="editAccForm.role !== 'company'" label="所属人员" prop="spid">
        <el-select v-fixZoom filterable v-model="editAccForm.spid" placeholder="请选择所属人员" style="width: 100%">
          <el-option
            v-for="item in personOptions"
            :key="item.value"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-else label="所属人员" prop="supplier_pid">
        <el-select v-fixZoom filterable v-model="editAccForm.supplier_pid" placeholder="请选择所属人员" style="width: 100%">
          <el-option
            v-for="item in supplierOptions"
            :key="item.value"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="模块" prop="moduletag" v-if="ismoduletag">
        <el-checkbox-group v-model="editAccForm.moduletag">
          <el-checkbox label="居家"></el-checkbox>
          <el-checkbox label="机构"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="客服分组" v-if="editAccForm.role === 'csd' && moduletag !== 2">
        <el-radio-group v-model="editAccForm.customerservicetag">
          <el-radio label="2">计生</el-radio>
          <el-radio label="1">话务</el-radio>
          <el-radio label="3">外勤</el-radio>
          <el-radio label="4">话务/外勤</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div>
      <el-row style="margin: 0 30px">
        <el-col :span="12">
          <div class="cancel-btn" @click="closeAdd()">
            <span>取消</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="send-btn" @click="submitEditAcc('editAccForm')">
            <span>确定</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <div style="height: 30px"></div>
  </div>
</template>

<script>
import {updateuser} from '../../../api/account'

export default {
  name: 'accountEdit',
  model: {
    prop: 'editShow',
    event: 'change'
  },
  props: {
    accountEditRow: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      personOptions: [],
      supplierOptions: [],
      ismoduletag: true,
      roleOptions: [
        {value: 'superadmin', label: '超级管理者'},
        {value: 'admin', label: '管理者'},
        {value: 'op', label: '运营'},
        {value: 'csd', label: '客服'},
        {value: 'guest', label: '访客'},
        {value: 'company', label: '服务商'},
        {value: 'sv', label: '监管'}
      ],
      editAccForm: {
        id: '',
        username: '',
        password: '',
        role: '',
        spid: '',
        supplier_pid: '',
        moduletag: [],
        customerservicetag: ''
      },
      editAccRules: {
        username: [
          { required: true, message: '请输入登录昵称', trigger: 'blur' }
        ],
        spid: [
          { required: true, message: '请选择平台人员', trigger: 'change' }
        ],
        supplier_pid: [
          { required: true, message: '请选择服务商人员', trigger: 'change' }
        ],
        moduletag: [
          { type: 'array', required: true, message: '请至少选择一个模块', trigger: 'change' }
        ],
        role: [
          { required: true, message: '请选择权限', trigger: 'change' }
        ]
      },
      isShowRole: false,
      moduletag: ''
    }
  },
  created () {
    this.getEidtForm()
    this.personOptions = this.accountEditRow.persons
    this.supplierOptions = this.accountEditRow.supplierorgpersons
    this.moduletag = this.$store.state.user.moduletag
    if (this.moduletag === 3) { // 机构
      this.ismoduletag = true
    } else {
      // 1 2
      this.ismoduletag = false
    }
    let role = this.$store.state.user.role
    if (role !== 'superadmin') {
      this.roleOptions = [
        { value: 'admin', label: '管理者' },
        { value: 'op', label: '运营' },
        { value: 'csd', label: '客服' },
        { value: 'guest', label: '访客' },
        { value: 'company', label: '服务商' },
        { value: 'sv', label: '监管' }
      ]
    }
    if (this.moduletag === 2) {
      this.roleOptions = [
        { value: 'admin', label: '管理员' },
        { value: 'csd', label: '值班员' },
        { value: 'guest', label: '护工' }
      ]
    }
  },
  mounted () {
  },
  methods: {
    getEidtForm () {
      this.editAccForm.id = this.accountEditRow.row.id
      this.editAccForm.username = this.accountEditRow.row.username
      this.editAccForm.role = this.accountEditRow.row.role
      this.editAccForm.spid = parseInt(this.accountEditRow.row.spid)
      if (this.editAccForm.role === this.$store.state.user.role) {
        this.isShowRole = true
      }
      this.editAccForm.supplier_pid = parseInt(this.accountEditRow.row.supplier_pid)
      if (this.accountEditRow.row.moduletag === 3) {
        this.editAccForm.moduletag = ['居家', '机构']
      } else if (this.accountEditRow.row.moduletag === 2) {
        this.editAccForm.moduletag = ['机构']
      } else if (this.accountEditRow.row.moduletag === 1) {
        this.editAccForm.moduletag = ['居家']
      }
      this.editAccForm.customerservicetag = this.accountEditRow.row.customerservicetag + ''
      // console.log(this.editAccForm.moduletag)
    },
    submitEditAcc (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.editAccForm.role === 'company') {
            this.editAccForm.spid = 0
          } else {
            this.editAccForm.supplier_pid = 0
          }
          // console.log(this.editAccForm)
          let moduletag = ''
          if (this.editAccForm.moduletag.length === 2) {
            moduletag = 3
          } else if (this.editAccForm.moduletag[0] === '居家') {
            moduletag = 1
          } else if (this.editAccForm.moduletag[0] === '机构') {
            moduletag = 2
          }
          let customerservicetag = ''
          if (this.editAccForm.customerservicetag === '') {
            customerservicetag = 0
          } else {
            customerservicetag = parseInt(this.editAccForm.customerservicetag)
          }
          let data = {
            id: this.editAccForm.id,
            username: this.editAccForm.username,
            password: this.editAccForm.password,
            role: this.editAccForm.role,
            spid: this.editAccForm.spid,
            supplier_pid: this.editAccForm.supplier_pid,
            moduletag: moduletag,
            customerservicetag: customerservicetag
          }
          updateuser(data).then(res => {
            this.$notify({
              title: '成功',
              message: '成功更新登录账号',
              type: 'success',
              duration: 2000
            })
            this.golobleObject.updateTableAcc()
            this.$emit('change', false)
          }).catch(() => {
            this.$notify.error({
              title: '失败',
              message: '更新登录账号失败'
            })
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    closeAdd () {
      this.$emit('change', false)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/childComponents/accountEdit.vue